var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',_vm._b({class:{ invalid: _vm.showValidation && !_vm.isValid },attrs:{"href":_vm.fieldValue,"target":"_blank","rel":"noopener"}},'a',_vm.$attrs,false),[_vm._v("\n    "+_vm._s(_vm.placeholder || _vm.fieldValue)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }